import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import { Popover, PopoverModule } from 'primeng/popover';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { SkeletonModule } from 'primeng/skeleton';
import { LucideAngularModule } from 'lucide-angular';
import { NotificationsFacade } from '../../../modules/notifications/facades/notifications.facade';
import { NotificationInterface } from '../../../modules/notifications/interfaces/notification.interface';
import { TimeAgoPipe } from '../../../shared/pipes/time-ago.pipe';
import {
  notificationColorClass,
  notificationIcon,
  notificationRoute
} from '../../../modules/notifications/utils/notification-presentation.util';

@Component({
  selector: 'app-notifications-popover',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    PopoverModule,
    ButtonModule,
    BadgeModule,
    SkeletonModule,
    LucideAngularModule,
    TimeAgoPipe
  ],
  templateUrl: './notifications-popover.component.html',
  styleUrl: './notifications-popover.component.scss'
})
export class NotificationsPopoverComponent {
  @ViewChild('op') popover!: Popover;

  private readonly router = inject(Router);
  private readonly facade = inject(NotificationsFacade);

  readonly notifications = this.facade.notifications;
  readonly unreadCount = this.facade.unreadCount;
  readonly loading = this.facade.loading;

  readonly notifications$ = this.facade.notifications$;
  readonly unreadCount$ = this.facade.unreadCount$;
  readonly loading$ = this.facade.loading$;

  markAsRead(id: string, event?: Event): void {
    event?.stopPropagation();
    this.facade.markAsRead(id);
  }

  clearAll(): void {
    this.facade.markAllAsRead();
  }

  viewAll(): void {
    this.popover.hide();
    this.router.navigate(['/notifications']);
  }

  openPreferences(): void {
    this.popover.hide();
    void this.router.navigate(['/perfil'], { queryParams: { tab: 'notifications' } });
  }

  getIcon(notification: NotificationInterface): string {
    return notificationIcon(notification);
  }

  getColorClass(notification: NotificationInterface): string {
    return notificationColorClass(notification);
  }

  handleNotificationClick(notification: NotificationInterface): void {
    this.markAsRead(notification.id);

    const route = notificationRoute(notification);
    if (route) void this.router.navigateByUrl(route);

    this.popover.hide();
  }
}
